import React from "react";

function ScrollTopButton({ isVisible, onClick }) {
  return (
    <button
      type="button"
      aria-label="Scroll to top"
      className={`scroll-top d-flex align-items-center justify-content-center ${
        isVisible ? "active" : ""
      }`}
      onClick={onClick}
    >
      <i className="bi bi-arrow-up-short"></i>
    </button>
  );
}

export default ScrollTopButton;
